export const FOLDER_PATH_SEPARATOR = '/';

/**
 * Sort objects for dam folder tree
 */
export const FOLDER_SORTS = [
  {
    sortKey: 'Position',
    direction: 'asc',
    picto: 'mdi-sort',
    i18nKey: 'manual',
  },
  {
    sortKey: 'Label.fr_FR',
    direction: 'asc',
    picto: 'mdi-sort-alphabetical-ascending',
    i18nKey: 'name',
  },
  {
    sortKey: 'Label.fr_FR',
    direction: 'desc',
    picto: 'mdi-sort-alphabetical-descending',
    i18nKey: 'name',
  },
];
